<script>
	const _ = require('underscore');
	const model = require('model/model');
	const eBookService = require('services/eBookService');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const config = require('core/config').resources.media;
	const mediaBucketRoot = config.cdn || config.origin;
	const eBookBucket = mediaBucketRoot + '/data/media/ebooks';

	const fireEvent = analyticsUtilities.fireEvent;
	const NEXT_PAGE_EBOOK = analyticsUtilities.events.NEXT_PAGE_EBOOK;
	const PREVIOUS_PAGE_EBOOK = analyticsUtilities.events.PREVIOUS_PAGE_EBOOK;
	const GOTO_PAGE_EBOOK = analyticsUtilities.events.GOTO_PAGE_EBOOK;

	function fixUrl(url) {
		if (url.indexOf('index.html') === -1) {
			if (url.charAt(url.length - 1) !== '/') {
				url += '/';
			}
			url += 'index.html';
		}
		return url;
	}

	module.exports = {
		props: {
			article: {
				default: null
			},
			assignmentId: {
				default: null
			}
		},
		components: {
			'org-logo': require('components/svg/org-logo.vue').default,
			pagination: require('components/pagination.vue').default,
			'audio-player-ebook': require('components/audio-player-ebook.vue').default
		},
		modelData: {
			ebookPage: 'activePage'
		},
		data() {
			return {
				loadingEBook: false,
				eBookData: null
			};
		},
		computed: {
			url() {
				let a = this.article;
				if (a && a.ebook && a.ebook.url) {
					let url = a.ebook.url;
					return fixUrl(url);
				} else {
					return null;
				}
			},
			pages() {
				let data = this.eBookData;

				if (!data) {
					return [];
				}

				let slug = data.slug;
				let imageRoot = eBookBucket + '/' + slug + '/images/';

				return data.pages.map(p => {
					return _.assign({}, p, {
						src: p.image_filename ? imageRoot + p.image_filename : null,
						cover: p.layout === 'cover',
						title: p.layout.indexOf('title') !== -1
					});
				});
			},
			audioUrl() {
				let data = this.eBookData;
				if (!data) {
					return '';
				}

				let slug = data.slug;
				let audioRoot = eBookBucket + '/' + slug + '/audio/';

				return audioRoot + slug + '.mp3';
			},
			showAudio() {
				let audioStartTime = this.audioStartTime;
				let audioEndTime = this.audioEndTime;
				let audioUrl = this.audioUrl;

				let show = audioUrl && typeof audioStartTime === 'number' && typeof audioEndTime === 'number';

				return show;
			},
			audioStartTime() {
				let pageIndex = this.activePage;
				let pages = this.pages;
				let page = this.pages && this.pages.length ? pages[pageIndex] : null;

				if (page && typeof page.audio_start_time === 'number') {
					return page.audio_start_time;
				}
				return null;
			},
			audioEndTime() {
				let pageIndex = this.activePage;
				let pages = this.pages;
				let page = this.pages && this.pages.length ? pages[pageIndex] : null;

				if (page && typeof page.audio_end_time === 'number') {
					return page.audio_end_time;
				}
				return null;
			},
			eventData() {
				let article = this.article;
				let assignmentId = this.assignmentId;
				let activePage = this.activePage;

				return {
					pid: article.uuid,
					aid: assignmentId,
					tag: 'ebook',
					page: activePage
				};
			},
			fontSize() {
				let size = 'medium';
				let data = this.eBookData;

				if (data && data.font_size) {
					size = data.font_size;
				}

				return size;
			},
			authorsByline() {
				let byline = '';
				let data = this.eBookData;

				if (data && data.author_byline) {
					byline = data.author_byline;
				} else if (data.authors) {
					byline = 'By ' + data.authors.join(' and ');
				}

				return byline;
			},
			illustratorsByline() {
				let byline = '';
				let data = this.eBookData;

				if (data && data.illustrator_byline) {
					byline = data.illustrator_byline;
				} else if (data.illustrators) {
					byline = 'Illustrations by  ' + data.illustrators.join(' and ');
				}

				return byline;
			},
			additionalNote() {
				let note = '';
				let data = this.eBookData;

				if (data && data.additional_note) {
					note = data.additional_note;
				}

				return note;
			}
		},
		watch: {
			article: {
				handler(a) {
					if (a && a.ebook && !a.ebook.url) {
						this.loadingEBook = true;
						eBookService
							.get(a.uuid)
							.then(response => {
								this.loadingEBook = false;
								if (response) {
									this.eBookData = response;
								} else {
									this.eBookData = null;
								}
							})
							.catch(err => {
								this.loadingEBook = false;
								this.eBookData = null;
							});
					}
				},
				immediate: true
			}
		},
		mounted() {
			let ebookPage = model.get('ebookPage');
			if (typeof ebookPage !== 'number') {
				ebookPage = 0;
			}
			this.goToPage(ebookPage);
		},
		methods: {
			goToPage(pageIndex) {
				model.set('ebookPage', pageIndex);
			},
			onNextPageClick(page) {
				let eventData = this.eventData;
				fireEvent(NEXT_PAGE_EBOOK, eventData);
			},
			onPreviousPageClick(page) {
				let eventData = this.eventData;
				fireEvent(PREVIOUS_PAGE_EBOOK, eventData);
			},
			onGoToPageClick(page) {
				let eventData = this.eventData;
				fireEvent(GOTO_PAGE_EBOOK, eventData);
			}
		}
	};
</script>
<template>
	<div :class="['ebook-container', `font-${fontSize}`, { 'tier-2': pages && pages.length }]">
		<div class="full-ui">
			<!-- Tier 1 eBook -->
			<iframe
				v-if="url"
				v-iframe-scaled-to-parent
				width="1297"
				height="991"
				scrolling="no"
				frameborder="0"
				allowfullscreen="allowfullscreen"
				:src="url">
			</iframe>
			<!-- Tier 2 eBook -->
			<div
				v-else-if="pages.length > 0"
				class="ebook-tier-2"
				ref="ebook">
				<div class="ebook-wrapper">
					<audio-player-ebook
						v-if="showAudio"
						:src="audioUrl"
						:start-time="audioStartTime"
						:end-time="audioEndTime"
						:event-data="eventData">
					</audio-player-ebook>
					<div
						v-for="(page, pageIndex) in pages"
						:key="page.src"
						v-show="pageIndex === activePage"
						class="ebook-page"
						:class="'layout-' + page.layout">
						<div
							class="ebook-image-container"
							v-if="page.src">
							<img :src="page.src" />
						</div>
						<div
							class="ebook-text"
							v-if="!page.title && !page.cover">
							<span
								class="ebook-text-body"
								v-html="page.html"></span>
							<div
								v-if="pageIndex === pages.length - 1"
								class="last-page-indicator"></div>
						</div>
						<div
							class="ebook-text ebook-title-page"
							v-if="page.title">
							<div
								class="ebook-title"
								v-html="eBookData.title"></div>
							<div
								class="ebook-byline"
								v-if="authorsByline">
								{{ authorsByline }}
							</div>
							<div
								class="ebook-illustrations"
								v-if="illustratorsByline">
								{{ illustratorsByline }}
							</div>
							<div class="ebook-library">
								From the
								<div>
									<org-logo></org-logo>
								</div>
								Library
							</div>
							<div
								class="additional-note"
								v-if="additionalNote"
								v-html="additionalNote"></div>
							<span class="title-notice">
								<div
									class="ebook-copyright"
									v-if="eBookData.copyright"
									v-html="eBookData.copyright"></div>
								<div class="ebook-created">
									This eBook was created by the nonprofit ReadWorks® and our network of leading researchers and teachers in research-based reading
									comprehension instruction.
								</div>
								<div
									class="ebook-isbn"
									v-if="eBookData.isbn">
									ISBN {{ eBookData.isbn }}
								</div>
							</span>
						</div>
					</div>
				</div>
				<org-logo class="nav-org-logo"></org-logo>
				<pagination
					ref="pagination"
					:total="pages.length"
					:on-page-change="goToPage"
					:page-size="1"
					:pages-to-show="11"
					:page="activePage"
					:on-next-page="onNextPageClick"
					:on-previous-page="onPreviousPageClick"
					:on-go-to-page="onGoToPageClick"
					class="ebook-nav">
				</pagination>
			</div>
		</div>
		<div class="small-ui">Sorry, you’ll need a bigger screen to see this eBook.</div>
	</div>
</template>
<style lang="scss">
	@use 'sass:math';

	@import 'mixins/flexbox';
	@import 'config/colors';
	@import 'config/variables';
	@import 'config/type';

	$top-img-flex: 2;
	$top-text-flex: 1;
	$top-img-height: percentage(math.div($top-img-flex, ($top-img-flex + $top-text-flex)));

	$sbs-img-flex: 4;
	$sbs-text-flex: 3;

	$ratio-width: 16;
	$ratio-height: 9;
	$ratio-height-percentage: percentage(math.div($ratio-height, $ratio-width));

	$ebook-min-width: 850px;
	$ebook-min-height: $ebook-min-width * math.div($ratio-height, $ratio-width);

	.ebook-container {
		width: 100%;
		margin-top: 0.7rem;
		overflow: hidden;
		font-size: 17px;

		> .full-ui {
			display: none;
		}

		&.font-xsmall {
			font-size: 11px;
		}

		&.font-small {
			font-size: 14px;
		}

		&.font-large {
			font-size: 20px;
		}

		&.font-xlarge {
			font-size: 23px;
		}

		&.tier-2 {
			overflow: auto;
		}

		.ebook-tier-2 {
			position: relative;
			min-height: $ebook-min-height;
			min-width: $ebook-min-width;

			@media only screen and (min-width: $bp-width-lg) {
				font-size: 1.25em;
			}

			font-family: var(--custom-font-family, $helvetica);
			line-height: 1.5;
			@include flexbox();
			@include flex-direction(column);

			.ebook-wrapper {
				position: relative;
				padding-bottom: $ratio-height-percentage;
				background-color: $c-blue-lighter;
				@include flex(1);
				@include flexbox();
				@include flex-direction(column);
				@include justify-content(center);

				.ebook-page {
					position: absolute;
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					@include flexbox();
					@include flex(1);

					&.layout-top,
					&.layout-title_top {
						@include flex-direction(column);

						.ebook-image-container {
							@include flex($top-img-flex);
							height: $top-img-height;
							max-height: $top-img-height;

							> img {
								max-height: 100%;
								height: auto;
								width: auto;
							}
						}

						.ebook-text {
							@include flex($top-text-flex);
							margin: $size-medium 4rem;
						}
					}

					&.layout-sbs,
					&.layout-title_sbs,
					&.layout-cover,
					&.layout-image_only,
					&.layout-text_only {
						.ebook-image-container {
							@include flex($sbs-img-flex);

							> img {
								max-width: 100%;
								max-height: 100%;
								position: absolute;
								top: 0;
								bottom: 0;
								margin: auto;
								left: 0;
								right: 0;
							}
						}

						.ebook-text {
							@include flex($sbs-text-flex);
							margin: 0rem $size-medium;
						}
					}

					&.layout-image_only {
						.ebook-text {
							display: none;
						}
					}

					&.layout-text_only {
						.ebook-image-container {
							display: none;
						}

						.ebook-text-body {
							// Don't allow text to be under play icon
							padding: 0rem 3rem;
						}
					}

					.ebook-image-container {
						position: relative;
						text-align: center;
					}

					.ebook-text {
						@include flexbox();
						@include flex-direction(column);
						@include align-items(center);
						@include justify-content(center);
						position: relative;

						&.ebook-title-page {
							text-align: center;

							.ebook-title {
								font-size: $size-large;
								max-width: 100%;
							}

							.ebook-byline,
							.ebook-illustrations,
							.ebook-library,
							.additional-note {
								font-size: 1rem;
							}

							.ebook-byline {
								padding-top: $size-smedium;
							}

							.ebook-library {
								padding: $size-smedium 0rem;
							}

							.additional-note {
								padding-bottom: $size-smedium;
							}

							.ebook-copyright,
							.ebook-created,
							.ebook-isbn {
								font-size: 0.5rem;
							}

							.title-notice {
								max-width: 15rem;
							}
						}

						.ebook-text-body {
							max-width: 50rem;
							width: 100%;
						}
					}

					.last-page-indicator {
						position: absolute;
						bottom: $size-medium;
						right: $size-medium;
						width: 1.5rem;
						height: 1.5rem;
						background-color: $c-blue;
						z-index: 2;
					}
				}

				.ebook-audio-player {
					position: absolute;
					top: $size-medium;
					left: $size-medium;
				}
			}

			.org-logo {
				fill: $c-blue;
				height: 1.25rem;
				margin: 0.375rem 0;
			}

			.nav-org-logo {
				display: none;
				fill: $c-blue;
				position: absolute;
				bottom: 0.5rem;
				right: 0.5rem;
				z-index: 2;

				@media only screen and (min-width: $bp-width-lg) {
					display: inherit;
				}
			}

			.pagination.ebook-nav {
				background-color: $c-blue-lighter;
				position: relative;
				text-align: center;
				margin: 0;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}

	.ebook-container iframe {
		overflow: hidden;
		border: none;
	}

	@media only screen and (min-width: $bp-width-med) {
		.ebook-container {
			> .full-ui {
				display: inherit;
			}

			> .small-ui {
				display: none;
			}
		}
	}
</style>
